export const FrenchData = [
  { 
    heading: "Pilote d'Outil d'Évaluation",
    atpSection: {
      introMessage: {
        quote: "Nous envisageons un outil d'évaluation de véhicules basé sur l'IA pour révolutionner la façon dont nous évaluons les véhicules. Votre participation à ce pilote est inestimable alors que nous ouvrons la voie à l'utilisation de la technologie pour mieux servir nos clients.",
        author: {
          name: "Antonio Ward",
          designation: "Directeur Général - Véhicules Finis",
          photo: '/Assets/images/photo.jpg',
        }
      },
      introVideoTitle: "Introduction au Pilote"
    },
    purposeSection: {
      heading: "Objectif du pilote",
      description: "Utilisez les applications de focalx pour voir si vous pouvez créer des évaluations facilement",
      taskHeading: "Vos tâches",
      tasks: [
        "Mettez cette page en favori",
        'Installez l\'application "Inspection Auto" (Scannez le code QR présent en bas de cette page)',
        "Connectez-vous avec les identifiants fournis par votre responsable.",
        "Prenez toutes les images de la voiture lors de l'inspection",
        "Remplissez l'enquête VASCOR après avoir reçu chaque rapport."
      ],
      timelineHeading : "Calendrier du Pilote",
    },
    inspectionSection: {
      heading: "Formation à l'Inspection : Comment effectuer une inspection avec l'application ?",
      downloadManual: "Télécharger le Manuel",
      relatedVideosTitle: "Consultez nos tutoriels de 30 secondes ici :",
      relatedVideos: [
        {
          poster: '/Assets/images/user-flow-poster.png',
          video: "app-demo-walkthrough.mp4",
          title: "1. Flux d'utilisateurs:",
          description: "Présentation rapide de bout en bout du flux d'utilisateurs.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-01.png',
          video: "app-demo-walkthrough.mp4",
          title: "2. Télécharger et Installer :",
          description: "Disponible à la fois sur l'App Store et Google Play, téléchargez et installez l'application 'Inspection Auto' et commencez vos inspections.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-03.png',
          video: 'app-demo-walkthrough.mp4',
          title: "3. Ajouter des Inspections :",
          description: "Scannez la plaque d'immatriculation ou le VIN, ajoutez le type de véhicule et commencez votre nouvelle inspection.",
          time: "0m16s"
        },
        {
          poster: '/Assets/images/Video-04.png',
          video: "app-demo-walkthrough.mp4",
          title: "4. Système d'Inspection Guidé par l'IA :",
          description: "Capturez votre véhicule avec l'aide de notre système d'orientation par IA et faites détecter et documenter vos dommages dans l'application.",
          time: "0m26s"
        },
        {
          poster: '/Assets/images/Video-02.png',
          video: "app-demo-walkthrough.mp4",
          title: "5. Parcourir les Inspections :",
          description: "Consultez vos inspections en parcourant les dommages documentés et les images de votre véhicule.",
          time: "0m30s"
        },
        {
          poster: '/Assets/images/Video-07.png',
          video: "app-demo-walkthrough.mp4",
          title: "6. Télécharger le Rapport PDF :",
          description: "Téléchargez le rapport complet sur les dommages de votre véhicule sur votre téléphone pour un accès rapide.",
          time: "0m20s"
        },
        {
          poster: '/Assets/images/Video-05.png',
          video: "app-demo-walkthrough.mp4",
          title: "7. Ajouter un Dommage Manuellement :",
          description: "Ajoutez tout dommage supplémentaire grâce à la fonction 'Ajouter un Dommage'.",
          time: "0m39s"
        },
        {
          poster: '/Assets/images/Video-08.png',
          video: "app-demo-walkthrough.mp4",
          title: "8. Connexion et Consultation de vos Inspections complétées :",
          description: "Recevez un e-mail avec toutes les images de votre véhicule et les dommages détectés, puis connectez-vous avec vos identifiants dans le système web pour consulter vos inspections.",
          time: "0m57s"
        },
        {
          poster: '/Assets/images/Video-09.png',
          video: "app-demo-walkthrough.mp4",
          title: "9. Comment envoyer des liens uniques au client ?",
          description: "Un aperçu rapide de la façon d'envoyer à vos clients un lien afin qu'ils puissent effectuer une inspection du véhicule.",
          time: "0m57s"
        }
      ]       
    },
    helpSection: {
      heading: "Nous sommes là pour vous aider 24/7",
      chatHeading: "Discutez avec nous",
      emailHeading: "Écrivez-nous un email",
      chat: {
        intercom: "Intercom",
        whatsapp: "+502-570-3238",
        weChat: "WeChat",
        emailAddress: "contact@focalx.ai"
      },
      formHeading: "Laissez-nous un message et votre adresse e-mail",       
      form: {
        nameFiled: "Entrez votre nom",
        emailField: "Entrez votre e-mail",
        commentField: "Entrez votre message",
        buttonText: "Soumettre",
      }
    },
    faqSection: {
      heading: "FAQ",
      accordionItems: [
        {
          accordianTitle: "Les images doivent-elles correspondre aux gabarits ?",
          accordianContent: ["Non, ce n'est pas nécessaire. Faites de votre mieux et plus l'image est proche de la voiture, mieux c'est. Mais les gabarits sont là simplement pour vous orienter sur l'image que vous devez prendre."]
        },
        {
          accordianTitle: "Combien de temps faut-il pour obtenir mes résultats ?",
          accordianContent: ["Une fois que toutes les images du véhicule ont été téléchargées, les résultats devraient être dans votre boîte de réception en moins de 30 minutes. C'est parce que c'est un pilote et c'est la première semaine. Plus vous utilisez l'application, plus elle apprend et plus elle devient rapide."]
        },
        {
          accordianTitle: "Que signifient ces K1, K2…K5 ?",
          accordianContent: [
            "K1 : Vous pouvez nettoyer cela",
            "K2 : Vous pouvez polir cela",
            "K3 : Petit dommage que vous ne pouvez pas réparer vous-même",
            "K4 : Un professionnel doit réparer cela",
            "K5 : La pièce pourrait avoir besoin d'être remplacée"]
        },
        {
          accordianTitle: "La voiture doit-elle être nettoyée avant l'évaluation ?",
          accordianContent: ["Pas nécessairement. Le système détectera les dommages même si la voiture n'est pas propre. Mais ce n'est pas magique, donc si l'œil humain ne peut pas voir le dommage et que le dommage ne peut pas être vu sur la photo, l'IA ne peut pas le détecter."]
        },
        {
          accordianTitle: "Dois-je prendre toutes les images ?",
          accordianContent: ["Oui, pour que le système effectue son analyse, toutes les images doivent être prises et téléchargées pour garantir un rapport d'évaluation standardisé et complet."]
        },
        {
          accordianTitle: "Les informations du client seront-elles partagées ?",
          accordianContent: ["Non, elles ne le seront pas. Aucun nom ou information client n'est partagé dans ce pilote et aucune des données générées n'est utilisée à des fins commerciales en dehors de VASCOR et de vous évaluer les performances de cet outil."]
        },
        {
          accordianTitle: "Que dois-je faire si je constate une divergence ou si j'ai un problème avec l'application ?",
          accordianContent: ["Assurez-vous de contacter le support, ils vous guideront vers une résolution. Mais n'oubliez pas de également le noter dans votre enquête post-évaluation. Plus vous pouvez fournir de détails, mieux c'est."]
        }          
      ]
    },
    downloadSection: {
      content: {
        downloadNow: "Télécharger maintenant",
        autoInspection: "Inspection Auto",
        description: "Trouvez-le sur l'App Store ou Google Play en le recherchant ou en scannant le code QR ci-dessous.",    
      }
    },
    footer: "© FocalX ApS. Tous droits réservés.",
    lockScreen: {
      title: "Entrez le PIN pour Accéder",
      buttonText: "Vérifier",
    },
  }
];
